export const DEFAULT_STORE_OBJECT = {
  progressing: false,
  success: false,
  error: false,
  data: null,
  message: '',
};
